import { render, staticRenderFns } from "./addresses.vue?vue&type=template&id=7fadbe6e&scoped=true&"
import script from "./addresses.vue?vue&type=script&lang=js&"
export * from "./addresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fadbe6e",
  null
  
)

export default component.exports